export default __webpack_public_path__ + "static/media/icon-note-2.e6c445a2.svg";